const ComplaintActionOptions = {
  SupportStaff: [
    { code: "SRCLSD", action: "Successfully Resolved: Submit to Supervisor for Closure", updatedStatus: "Open", sent_to_tag: "fwd_supv_fr_close", next_lvl_optns: [] },
    { code: "POH", action: "Put on hold: Justification recorded", updatedStatus: "OnHold", sent_to_tag: "compl_on_hold", next_lvl_optns: [] }
  ],

  Supervisor: [
    { code: "SUPCLOSE", action: "Close Complaint", updatedStatus: "Closed", sent_to_tag: "compl_closed_by_supv", next_lvl_optns: [] },
    { code: "REASSI", action: "Reassign Complaint to other SupportStaff", updatedStatus: "Open", sent_to_tag: "fwd_reaasign_ss", next_lvl_optns: [] },
    { code: "RBDCSS", action: "Return Complaint to Support Staff for Action", updatedStatus: "Open", sent_to_tag: "fwd_to_oldss_foraction", next_lvl_optns: [] }
  ],

  SupervisorEscalated: [
    { code: "RESOLVEFWDL1", action: "Resolved: Forward to L1Support for Closure", updatedStatus: "Open", sent_to_tag: "supv_resolved_fwd_l1", next_lvl_optns: [] },
    { code: "REASSI", action: "Reassign Complaint to other SupportStaff", updatedStatus: "Open", sent_to_tag: "fwd_reaasign_ss", next_lvl_optns: [] },
    { code: "RBDCSS", action: "Return Complaint to Support Staff for Action", updatedStatus: "Open", sent_to_tag: "fwd_to_oldss_foraction", next_lvl_optns: [] }
  ],

  user: [
    { code: "ESCALATE", action: "Raise Grievance: Complaint Not Resolved", updatedStatus: "Open", sent_to_tag: "escalated_to_l1", next_lvl_optns: [] }
  ],

  L1Support: [
    { code: "L1CLOSE", action: "Close Complaint", updatedStatus: "Closed", sent_to_tag: "compl_closed_by_l1", next_lvl_optns: [] },
    { code: "L1FWDSUP", action: "Return to Supervisor for Action", updatedStatus: "Open", sent_to_tag: "l1_fwd_sup_foraction", next_lvl_optns: [] }
  ],

  SupervisorAllComplaints: [
    { code: "REASSI", action: "Reassign Complaint to other SupportStaff", updatedStatus: "Open", sent_to_tag: "fwd_reaasign_ss", next_lvl_optns: [] },
    { code: "OBO_SRCLSD", action: "On Behalf of Support Staff: Submit for Closure", updatedStatus: "Open", sent_to_tag: "fwd_supv_fr_close", next_lvl_optns: [] },
    { code: "OBO_POH", action: "On Behalf of Support Staff: Put on Hold", updatedStatus: "OnHold", sent_to_tag: "compl_on_hold", next_lvl_optns: [] }
  ]
}

export default ComplaintActionOptions;
